"use client";

import React from "react";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MilSpecStandards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="milspecstandards" className="bg-[#0F1B2D] py-16 md:py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-20 pointer-events-none" />
      
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl relative z-10 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex items-center gap-3 mb-6">
          <div className="flex items-center justify-center size-10 rounded-lg bg-primary/20 text-primary">
            <ShieldCheck className="size-6" />
          </div>
          <span className="text-primary font-semibold tracking-wide uppercase text-sm font-default">
            Compliance & Standards
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 font-default leading-tight">
          Which MIL-SPEC and Standards Apply to Phenolic?
        </h2>
        
        <p className="text-lg md:text-xl text-gray-300 mb-8 font-default leading-relaxed">
          Engraving-grade phenolic is specified in defense and marine nameplate work under MIL-SPEC standards. Depending on the requirement, these may include MIL-DTL-15024 (marking for identification plates) and MIL-P-15035 (phenolic material for nameplates), among others a project may call out.
        </p>

        <div className="bg-white/5 border border-white/10 rounded-lg p-6 md:p-8 mb-10 shadow-lg backdrop-blur-sm">
          <p className="text-base md:text-lg text-gray-300 font-default leading-relaxed">
            Evermark Industrial Solutions engraves phenolic designed to align with the MIL-SPEC standard a project specifies when the material, type, and content are properly specified. Evermark produces the marking and does not certify the material or the part; which standard and type designation apply, and whether a given material meets them, depend on the project specification and the governing authority. Evermark recommends confirming the required MIL-SPEC type and grade with the engineer of record or a qualified specialist. Specific MIL-SPEC type designations and certificates of conformance: {"{{verify: MIL-SPEC types, grades, and CoC availability}}"}.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
          <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 font-default">
            <Link to="/ContactPage">
              MIL-SPEC phenolic nameplates
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-white/20 text-white hover:bg-white/10 hover:text-white font-default bg-transparent">
            
          </Button>
        </div>
      </div>
    </section>;
}